import myAxios from "./myAxios";
import * as actions from "./actions";
import * as currentUserActions from "./currentUserActions";
import * as currentEpisodeActions from "./currentEpisodeActions";
import * as poppinFormActions from "./poppinFormActions";
import * as socialControlsActions from "./socialControlsActions";
import * as storyActions from "./storyActions";
import { isLogged } from "../components/ScrollReader/helpers";
import { readingActions } from "./index";

export const replySend = form => dispatch => {
  dispatch(actions.showSmallSpinner());

  myAxios({
    url: routes().comment_replies,
    method: "POST",
    data: form
  }).then(response => {
    dispatch(actions.addReplyFor(response.data.commented_id, response.data.commented_type, response.data));
    dispatch(currentEpisodeActions.updatePopCommentsCounter("increment"));
    dispatch(actions.closeReplyForm());
    dispatch(actions.hideSmallSpinner());
  });
};

export const commentDelete = (deleteConfirmation, successMsg, cutted) => dispatch => {
  dispatch(actions.showSmallSpinner());

  let endpoint;
  if (deleteConfirmation.parentType == "Comment") {
    endpoint = routes().comments + deleteConfirmation.parentId;
  } else if (deleteConfirmation.parentType == "TsukkomiComment") {
    endpoint = routes().post_tsukkomi_comment + "/" + deleteConfirmation.parentId;
  } else if (deleteConfirmation.parentType == "PopCommentReply") {
    endpoint = routes().comment_replies + "/" + deleteConfirmation.parentId;
  }

  myAxios({
    url: endpoint,
    method: "DELETE"
  }).then(response => {
    if (deleteConfirmation.parentType == "PopCommentReply") {
      dispatch(reloadReplies(deleteConfirmation, cutted));
    } else {
      if (deleteConfirmation.parentType == "TsukkomiComment") {
        dispatch(readingActions.poppinsToggle());
        dispatch(currentEpisodeActions.poppinDelete(deleteConfirmation));
        dispatch(readingActions.poppinsToggle());
      }
      dispatch(actions.removePopComment(deleteConfirmation));
    }

    dispatch(currentEpisodeActions.updatePopCommentsCounter("decrement"));
    dispatch(actions.hideSmallSpinner());
    setNoticeSuccess(successMsg);
  });
};

export const reloadReplies = (deleteConfirmation, cutted) => dispatch => {
  myAxios({
    url: routes().get_comment_replies,
    method: "GET",
    params: {
      parent_id: deleteConfirmation.commentedId,
      parent_type: deleteConfirmation.commentedType
    }
  }).then(response => {
    dispatch(
      actions.setRepliesFor(
        deleteConfirmation.commentedId,
        deleteConfirmation.commentedType,
        response.data.pop_comment_replies,
        cutted
      )
    );
  });
};

export const popCommentOrReplyUpdate = (form, successMsg) => dispatch => {
  dispatch(actions.showSmallSpinner());

  myAxios({
    url: form.endpoint,
    method: "PUT",
    data: form
  }).then(response => {
    dispatch(actions.updatePopCommentOrReply(form));
    setNoticeSuccess(successMsg);
    dispatch(actions.closeUpdateForm());
    if (form.parent_type === "TsukkomiComment") {
      dispatch(currentEpisodeActions.poppinBodySet(response.data));
    }
    dispatch(actions.hideSmallSpinner());
  });
};

export const popReactionSend = props => dispatch => {
  dispatch(actions.showSmallSpinner());

  myAxios({
    url: routes().post_pop_reaction,
    method: "POST",
    data: {
      parent_id: props.parent_id,
      parent_type: props.parent_type,
      action: props.action
    }
  }).then(response => {
    dispatch(actions.setReactionFor(props.commented_id, props.commented_type, response.data));
    dispatch(actions.hideSmallSpinner());
  });
};

export const poppinMovedStore = (pinIdx, pageIdx, props) => dispatch => {
  myAxios({
    url: routes().post_tsukkomi_comment + "/" + props.id,
    method: "PUT",
    data: { pos_x: props.posX, pos_y: props.posY }
  }).then(response => {
    dispatch(currentEpisodeActions.poppinDraggedSet(pinIdx, pageIdx, props.posX, props.posY));
  });
};

export const poppinFormSend = props => dispatch => {
  myAxios
    .post(routes().post_tsukkomi_comment, {
      body: props.body,
      page_id: props.pageId,
      pos_x: props.posX,
      pos_y: props.posY
    })
    .then(response => {
      dispatch(poppinFormActions.poppinFormClose());
      dispatch(currentEpisodeActions.poppinAdd(props.pageIdx, response.data));
      dispatch(actions.preppendCurrentEpisodeCommentsWithNewPoppin({ ...response.data, page_number: props.pageIdx + 1 }));
      dispatch(currentEpisodeActions.updatePopCommentsCounter("increment"));
    });
};

export const fetchInitialData = options => dispatch => {
  const splitedPath = document.location.pathname.split("webreader/")[1].split("/");
  const storyId = splitedPath[0];
  const episodeId = splitedPath[1];
  let resolvedData = {};

  return dispatch(storyActions.fetchStory(storyId))
    .then(storyData => {
      resolvedData = Object.assign({}, resolvedData, { storyData });
      return dispatch(currentEpisodeActions.fetchCurrentEpisode(episodeId));
    })
    .then(currentEpisodeData => {
      resolvedData = Object.assign({}, resolvedData, { currentEpisodeData });
      return isLogged() && dispatch(currentUserActions.fetchCurrentUser());
    })
    .then(currentUserData => {
      if (currentUserData) {
        resolvedData = Object.assign({}, resolvedData, { currentUserData });
      }

      return (
        options &&
        options.withPopComments &&
        socialControlsActions.fetchCurrentEpisodeCommentsContent(dispatch, options.args)
      );
    })
    .then(currentEpisodePopCommentsData => {
      if (currentEpisodePopCommentsData) {
        resolvedData = Object.assign({}, resolvedData, { currentEpisodePopCommentsData });
      }

      return resolvedData;
    })
    .catch(err => {
      console.log(err);
    });
};
